import { Component } from 'react';
import RoleTable from './RoleTable';
import UserHasRoleTable from './UserHasRoleTable';
import { IDBRole, IUserRoleAssignment } from './types';
import ActualUserHasRoleTable from './ActualUserHasRoleTable';

interface IProps {
    // Define your props here
}

export interface IUserRoleState {
    dbRoles: IDBRole[] | null,
    userAssignedRoles: IUserRoleAssignment[] | null,
}

class UserRole extends Component<IProps, IUserRoleState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            dbRoles: null,
            userAssignedRoles: null
        };
    }

    setStateProperty = (propertyName: keyof IUserRoleState, value: any) => {
        this.setState({ [propertyName]: value } as Pick<IUserRoleState, keyof IUserRoleState>);
    }

    render() {
        const { dbRoles } = this.state;
        return (
            <div className="ms-Grid">
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm7">
                        <UserHasRoleTable dbRoles={dbRoles} />
                    </div>
                    <div className="ms-Grid-col ms-sm5">
                        <RoleTable
                            dbRoles={dbRoles}
                            setStateProperty={this.setStateProperty} />
                    </div>
                    <div className="ms-Grid-col ms-sm12">
                        <ActualUserHasRoleTable />
                    </div>

                </div>
            </div>
        );
    }
}

export default UserRole;